import React, { memo } from 'react';

import { useHasBot } from '@src/reducers/header';

export const DisclaimerHelper: React.FC = memo(({ children }) => {
    const hasBot = useHasBot();

    return !hasBot ? <div>{children}</div> : null;
});
